<div class="rounded-circle">
  <p class="rounded-circle-content">{{ step }}</p>
</div>
